import {
  fertilizerSolidStandardUnitsList,
  fertilizerLiquidStandardUnitsList
} from 'components/Modals/CustomProductModal/components/FertilizerProductForm';
import _ from 'lodash';
import { getUnitLabel } from 'helpers/unitsAbbreviation';

export const serviceUnits = [
  {
    key: 'acre',
    value: 'acre'
  },
  {
    key: 'hectare',
    value: 'hectare'
  },
  {
    key: 'hour',
    value: 'hour'
  },
  {
    key: 'day',
    value: 'day'
  }
];

export const fertUnits = [
  {
    key: 'centiliter',
    value: 'centiliter'
  },
  {
    key: 'cubic foot',
    value: 'cubic foot'
  },
  {
    key: 'cubic inch',
    value: 'cubic inch'
  },
  {
    key: 'cubic meter',
    value: 'cubic meter'
  },
  {
    key: 'cubic yard',
    value: 'cubic yard'
  },
  {
    key: 'fluid ounce',
    value: 'fluid ounce'
  },
  {
    key: 'milliliter',
    value: 'milliliter'
  },
  {
    key: 'pint',
    value: 'pint'
  },

  {
    key: 'gram',
    value: 'gram'
  },

  {
    key: 'long ton',
    value: 'long ton'
  },

  {
    key: 'ounce',
    value: 'ounce'
  }
];

export const fertCombinedUnits = _.uniqBy(
  fertUnits.concat(
    fertilizerLiquidStandardUnitsList,
    fertilizerSolidStandardUnitsList
  ),
  'key'
);

// Withdrawn from fertilizer only — services still measure in acres. Shared with
// the save path, which refuses a product still sitting on one of these.
export const WITHDRAWN_FERTILIZER_UNITS = ['acre', 'acre inch', 'long ton'];

export const UNITS = {
  SERVICE: serviceUnits.map(unit => ({
    key: unit.value,
    value: unit.value,
    label: getUnitLabel(unit.key)
  })),
  FERTILIZER: fertCombinedUnits
    .filter(unit => !WITHDRAWN_FERTILIZER_UNITS.includes(unit.value))
    .map(unit => ({
      key: unit.value,
      value: unit.value,
      label: getUnitLabel(unit.key)
    }))
};
